import { BondsmanIdentifier } from './../shared/bondsman-identifier';
import { AuthenticationService } from './../shared/authentication.service';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { LicenseeInformationComponent } from './licensee-information/licensee-information.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChange, OnDestroy } from '@angular/core';
import { Bondsman } from './bondsman';
import { CountyService } from './../shared/county.service';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { mockBondsman1WAKE, mockBondsman1VANCE } from './bondsman.mock';

import { ActivatedRoute } from '@angular/router';
import { BondsmanSearchService } from './bondsman-search.service';
import { Subscription, Observable } from 'rxjs';
import { EventService } from '../shared/event.service';
import { CivilSearchService } from '../civil/civil-search.service';

@Component({
  selector: 'app-bondsman-detail',
  templateUrl: './bondsman-detail.component.html',
  styleUrls: ['./../case-view/civil/civil-case-view.component.less']
})
export class BondsmanDetailComponent implements OnInit, OnDestroy {
  errors: any[] = [];
  requestSubscriptionForCounty: Subscription;
  requestSubscriptionForForfeitures: Subscription;
  public bondsmanIdentifier: BondsmanIdentifier;  // current bondsman identifier
  public bondsman: Bondsman; // empty bondsman at construction time
  countyLicenseeFormGroup: FormGroup;
  counties: IMultiSelectOption[] = this.buildIMultiSelectOptions(CountyService.getCounties());
  tocOpen = true;
  tocOpening = false;
  showFieldCodeFlag = false;
  selectedCountyValue = '';
  defaultCountyValue = '';                // current default user county

  dateOptions = {  year: 'numeric', month: '2-digit', day: '2-digit' };
  searchRecordLastUpdateDate: string = new Date().toLocaleDateString('en-US', this.dateOptions);

  constructor(
    private bondsmanSearchService: BondsmanSearchService,
    private authenticationService: AuthenticationService,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private eventService: EventService,
    private civilSearchService: CivilSearchService,
  ) {
    const userCounty = this.authenticationService.getCurrentUser().authorization.geoName;
    this.defaultCountyValue = userCounty;
    this.selectedCountyValue = this.defaultCountyValue;

    // subscribe the bondsman details loaded observable and trigger loading forfeitures
    this.eventService.bondsmanDetailsLoaded$.subscribe(() => {
        // mock-up data for forfeitures and append it to the current bondsman
        if (this.bondsman.bondsmanIdentifier.licenseNumber === '1') {
          const wakeBondsman = new Bondsman(mockBondsman1WAKE.data);
          let forfeitures = wakeBondsman.getBondForfeitures();
          if (this.bondsman) {
            this.bondsman.setForfeitures(forfeitures);
          }
        } else {
          this.loadForfeitures(this.bondsman);
        }
    });

    // get the routing parameters and instantiate the bondsmanIdentifier object
    this.bondsmanIdentifier = new BondsmanIdentifier(this.route.snapshot.params['licensenumber']);
    this.bondsmanIdentifier.setStateLicenseId(this.route.snapshot.params['statelicenseid']);
    console.log( this.bondsmanIdentifier);
  }

  ngOnInit() {
    // set the form control for the cunnty dropdown list
    this.countyLicenseeFormGroup =
        new FormGroup({countyLookUp: new FormGroup({ countyControl: new FormControl() })  });

    // load the details
    this.route.paramMap.subscribe(paramMap => {
      this.bondsmanIdentifier = new BondsmanIdentifier(this.route.snapshot.params['licensenumber']);
      this.bondsmanIdentifier.setStateLicenseId(this.route.snapshot.params['statelicenseid']);
      this.loadDetailsForCounty(this.bondsmanIdentifier, this.defaultCountyValue);   // load bondsman details
    });
  }

  countySelected() {
    this.selectedCountyValue = this.countyLicenseeFormGroup.get('countyLookUp.countyControl').value;
    this.loadDetailsForCounty(this.bondsmanIdentifier, this.selectedCountyValue);
    // need to reset the forfeture data here or in load copy
  }

  getSelectedCounty(): string {
    return this.selectedCountyValue;
  }

  toggleTableOfContents() {
    this.tocOpen = !this.tocOpen;
    if (this.tocOpen) {
      this.tocOpening = true;
      setTimeout(() => {
        this.tocOpening = false;
        this.cd.markForCheck(); // force change detection to run to pick up this change
      }, 500); // Note: this duration must be the same as the transition duration in this component's styles
    }
  }
  private buildIMultiSelectOptions(items: string[]): IMultiSelectOption[] {
    return items.map(i => { return { 'id': i, 'name': i }; });
  }
  isProd(): boolean {
    return environment.production;
  }
  toggleFieldCodes() {
    this.showFieldCodeFlag = !this.showFieldCodeFlag;
    $('.field-code').toggle();
  }

  /**
   * load bondsman for the given bondsman state license id and county name
   * @param bondsmanIdentifier BondsmanIndentifier
   */
  loadDetailsForCounty(bondsmanIdentifier: BondsmanIdentifier, countyName: string): void {
     // load the update time first
     this.getSearchRecordLastUpdateDate();

    // load the details
    this.requestSubscriptionForCounty =
      this.bondsmanSearchService.findByStateLicenseIdAndCounty(bondsmanIdentifier, countyName)
         .subscribe(bondsman => {
            this.bondsman = bondsman;
            if (bondsmanIdentifier.licenseNumber === '1' && countyName === 'WAKE') {
              this.bondsman = new Bondsman(mockBondsman1WAKE.data);
            }
            if (bondsmanIdentifier.licenseNumber === '1' && countyName === 'VANCE') {
              this.bondsman = new Bondsman(mockBondsman1VANCE.data);
            }
            this.eventService.bondsmanDetailsLoaded();  // emitting bondsman loaded observable
            console.log('Successfully loaded the bondsman of County: ' + countyName);
         },
         errorMessage => { this.errors.push(errorMessage);
      });
  }
  /**
   * load forfeitures and append them to the current bondsman data
   * @param bondsmanIdentifier
   */
  loadForfeitures(bondsman: Bondsman): void {
    const forfeitureUri: string = bondsman.getBondForfeituresUri();
    if (forfeitureUri) {
      this.requestSubscriptionForForfeitures =
       this.bondsmanSearchService.findForfeituresByUri(forfeitureUri)
         .subscribe(forfeituresData => {
             bondsman.setForfeitures(forfeituresData.forfeitureIndexList);
          },
          errorMessage => { this.errors.push(errorMessage);
       });
    } else {
      this.requestSubscriptionForForfeitures =
       this.bondsmanSearchService.findForfeituresByLicenseNumber(bondsman.getLicenseNumber())
         .subscribe(forfeituresData => {
             bondsman.setForfeitures(forfeituresData.forfeitureIndexList);
          },
          errorMessage => { this.errors.push(errorMessage);
       });
    }
  }

  ngOnDestroy() {
    this.cancelAnyOutstandingRequest();
  }

  isRequestInFlight(): boolean {
    return this.requestSubscriptionForCounty &&
           !this.requestSubscriptionForCounty.closed;
  }

  isRequestForForeituresInFlight(): boolean {
    return this.requestSubscriptionForForfeitures &&
               !this.requestSubscriptionForForfeitures.closed;
  }
  private cancelAnyOutstandingRequest() {
    if (this.requestSubscriptionForCounty) {
      this.requestSubscriptionForCounty.unsubscribe();
    }
    if (this.requestSubscriptionForForfeitures ) {
      this.requestSubscriptionForForfeitures.unsubscribe();
    }
  }

  /**
   * get the last update date and notity of it through event service
   */
  getSearchRecordLastUpdateDate() {
    this.civilSearchService.getSearchRecordLastUpdateDate()
    .subscribe(lastUpdateDate => {
      this.searchRecordLastUpdateDate = lastUpdateDate;
       this.cd.markForCheck();   // force to detect the changes
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman-detail.component.ts